<template>
  <div class="table-container">
    <table class="custom-table">
      <thead>
        <tr>
          <th>X\Y</th>
          <th v-for="item in tableHeader" :key="item">{{ item }}</th>
        </tr>
      </thead>
      <tbody>
        <!-- 循环渲染每一行 -->
        <tr v-for="item in tableData" :key="item.label">
          <td>{{ item.label }}</td>
          <td v-for="col in item.columns" :key="col.key">
            {{ col.value }}
          </td>
          <td>{{ item.subtotal }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    // 图表配置项（必传）
    option: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      tableHeader: ["咸淡适中", "偏咸", "咸淡", "偏辣", "小计"],
      tableData: [],
      //   tableData: [
      //     {
      //       label: "很满意(5)",
      //       columns: [
      //         { key: "适中", value: "2(100%)" },
      //         { key: "偏咸", value: "2(100%)" },
      //         { key: "咸淡", value: "2(100%)" },
      //         { key: "偏辣", value: "2(100%)" },
      //       ],
      //       subtotal: 8,
      //     },
      //     {
      //       label: "满意(5)",
      //       columns: [
      //         { key: "适中", value: "2(100%)" },
      //         { key: "偏咸", value: "2(100%)" },
      //         { key: "咸淡", value: "2(100%)" },
      //         { key: "偏辣", value: "2(100%)" },
      //       ],
      //       subtotal: 8,
      //     },
      //     {
      //       label: "一般(5)",
      //       columns: [
      //         { key: "适中", value: "2(100%)" },
      //         { key: "偏咸", value: "2(100%)" },
      //         { key: "咸淡", value: "2(100%)" },
      //         { key: "偏辣", value: "2(100%)" },
      //       ],
      //       subtotal: 8,
      //     },
      //     {
      //       label: "不满意(5)",
      //       columns: [
      //         { key: "适中", value: "2(100%)" },
      //         { key: "偏咸", value: "2(100%)" },
      //         { key: "咸淡", value: "2(100%)" },
      //         { key: "偏辣", value: "2(100%)" },
      //       ],
      //       subtotal: 8,
      //     },
      //     {
      //       label: "很不满意(5)",
      //       columns: [
      //         { key: "适中", value: "2(100%)" },
      //         { key: "偏咸", value: "2(100%)" },
      //         { key: "咸淡", value: "2(100%)" },
      //         { key: "偏辣", value: "2(100%)" },
      //       ],
      //       subtotal: 8,
      //     },
      //   ],
    };
  },
  methods: {
    initData(newVal) {
      this.tableHeader = newVal.yAxis.options.map((item) => item.text);
      this.tableHeader.push("小计");
      const list1 = newVal.xaxis.options.map((item) => item.text);
      const list2 = newVal.yAxis.matrix;
      this.tableData = [];
      for (let i = 0; i < list1.length; i++) {
        let data = {};
        let datas = [];
        let subtotal = 0;
        for (let j = 0; j < list2.length; j++) {
          datas.push(
            list2[j][i].count + "(" + list2[j][i].percentage + ")" + "%"
          );
          subtotal += Number(list2[j][i].count);
        }
        data.label = list1[i];
        data.subtotal = subtotal;
        data.columns = datas.map((item, index) => ({
          key: list1[index],
          value: item,
        }));
        this.tableData.push(data);
      }
    },
  },
  watch: {
    // 监听配置项变化，自动更新
    option: {
      handler(newVal) {
        console.log("=p2or-r23[[2or-=2r2320-3ir23ir32]]", newVal);
        // this.dataObj = newVal;
        this.initData(newVal);
      },
      deep: true,
      immediate: true,
    },
  },
};
// import * as echarts from "echarts";
</script>

<style lang="scss" scoped>
.table-container {
  width: 100%;
  padding: 20px;
}

/* 核心：让每个单元格都显示独立边框 */
.custom-table {
  width: 100%;
  border-collapse: separate; /* 关键：不合并边框，让每个单元格边框独立 */
  border-spacing: 0; /* 去除单元格之间的间距，避免边框间隙 */
  text-align: center;
}

/* 表头和单元格都添加边框 */
.custom-table th,
.custom-table td {
  padding: 12px 8px; /* 适当内边距，让内容不拥挤 */
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
}

/* 处理边框重叠问题（可选优化） */
/* 第一列的左边框不重复 */
.custom-table th:first-child,
.custom-table td:first-child {
  border-left: 1px solid #ccc;
}

/* 第一行的上边框不重复 */
.custom-table th {
  background-color: #f5f5f5;
  border-top: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/crossAnalysis/table.vue